import { ProfileRobotUser } from '../generalSettings/UserProfile/redux/types'
import { useTranslation } from 'react-i18next'

export const useGetDisplayName = (profileRobotUser: ProfileRobotUser): string => {
  const { t } = useTranslation()
  const { robot, endUserName, alias } = profileRobotUser
  const displayName = alias ?? endUserName ?? (profileRobotUser.role === 'PRIMARY_CARER' ? t('ROBOT_SETTINGS.PROFILE.FORM.END_USER.PLACEHOLDER') : robot)
  return displayName as string
}
